import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Subtitle, Description, Title, Titlespan2 } from '../../components/title/index';
import PortfolioData from '../../data/portfolio/index';
import './portfolio.scss';

function Portfolio() {
    return (
        <section className="portfolio-wrapper" id="portfolio">
            <Container>
                <div className="main-title-wrapper">
                    <Subtitle
                        Class="site-subtitle"
                        Name="What we offer"
                    />
                    <Titlespan2
                        Class="sitemain-subtitle"
                        Name="Products &amp; Services"
                        Label=""
                    />
                    <Description
                        Class="site-dec"
                        Name="NGT Transformation Services has vast experience in helping businesses. We specalise in the following areas:"
                    />
                    <a href="/products-and-services">Learn More</a>
                </div>
                <Row>
                    {PortfolioData.map((data, i) => (
                        <Col lg={4} sm={6} key={data.id} className={`portfolio-${i}`}>
                            <div className="portfolio-content">
                                <div className="portfolio-first-block">
                                    <img src={data.img} alt="" title="" />
                                    <div className="portfolio-hover">
                                        <Title
                                            Class="portfolio-hover-title"
                                            Name={data.subtitle}
                                        />
                                        <Description
                                            Class="portfolio-hover-dec"
                                            Name={data.subcontent}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
}

export default Portfolio;
